import React from 'react';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { GenericErrorPage } from '@locus-taxy/encore-ui-toolkit';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const handleRetry = () => {
    // Go back in browser history
    window.history.back();
  };

  return (
    <GenericErrorPage
      title={t('errors.errorBoundary.pageNotFoundTitle')}
      message={t('errors.errorBoundary.pageNotFoundMessage')}
      showRetry={true}
      onRetry={handleRetry}
      retryButtonText={t('errors.errorBoundary.goBackButton')}
    />
  );
};
